import { reactEvents } from "../bridge/reactEvents";

export function FooBar({hello}:{hello:string}) {
    return <div>
        {hello}
        <button onClick={() => reactEvents.fooBar.dispatch()}>hej</button>
    </div>
}